import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectProps } from '@mui/material/Select';

interface Option {
    value: string;
    label: string;
}

export type SelectInputProps = SelectProps & {
    value?: string;
    options: Option[];
    label?: string;
    className?: string;
    required?: boolean;
    helperText?: string;
};

export function SelectInput({
    value = '',
    options,
    label = '',
    required = false,
    error,
    helperText,
    onChange,
    className,
    sx,
    fullWidth,
    ...rest
}: SelectInputProps) {
    return (
        <FormControl
            required={required}
            error={error}
            component="fieldset"
            sx={{ minWidth: 120, ...sx }}
            fullWidth={fullWidth}
        >
            {label && (
                <InputLabel shrink id={`${label}-label`}>
                    {label}
                </InputLabel>
            )}
            <FormGroup>
                <Select
                    {...rest}
                    error={error}
                    label={label}
                    labelId={`${label}-label`}
                    id={label}
                    value={value}
                    onChange={onChange}
                    displayEmpty
                    // sx={{ marginTop: 2 }}
                    MenuProps={{
                        PaperProps: {
                            sx: { backgroundColor: 'secondary' },
                        },
                    }}
                >
                    {options.map((o: Option) => {
                        return (
                            <MenuItem key={o.value} value={o.value}>
                                {o.label}
                            </MenuItem>
                        );
                    })}
                </Select>
                <FormHelperText error={error}>{helperText}</FormHelperText>
            </FormGroup>
        </FormControl>
    );
}
